export const aboutUs = {
  backgroundUrl: "/backgrounds/bg_art_train.jpg",
  title: "ESGPLAY: Sobre Nosotros",
  main: `Creado desde el 2017, ESGPLAY nació desde la visión de dos, en ese entonces "jóvenes" gamers: Johan "Speekz" Béjar y Edwin "traNksed" Palacin, a los cuales se les ocurrió la "grandiosa" idea de crear lo que ninguna empresa de videojuegos pudo establecer en Perú y menos en America Latina, crear la primera plataforma que se dedique e invierta a los Esports a nivel tecnológico. Ahí traNksed añadió: 
  "Pero empezemos con CS:GO", a lo cual yo acepté. Desde ahí empezó el ruedo`,
  founders: [
    {
      image: {
        src: "/esgplay/founders/johan-bejar.png",
        alt: "Johan Bejar Picture",
      },
      name: `Johan "Speekz" Bejar`,
      role: "CEO and Co-Founder",
      details:
        "Ingeniero de Sistemas graduado de la UPC, diplomado en Gestión de la Ciberseguridad y actualmente desarrollador de Software, se dedica en ESGPLAY al mantenimiento y desarrollo de la plataforma",
      socialMediaLinks: [
        {
          social: "email",
          href: "mailto:jbejar@esgplay.com",
        },
        {
          social: "facebook",
          href: "https://www.facebook.com/JSpeekzB",
        },
        {
          social: "twitter",
          href: "https://twitter.com/JSpeekzB",
        },
        {
          social: "linkedin",
          href: "https://www.linkedin.com/in/johan-bejar/",
        },
        {
          social: "discord",
          href: "Speekz#1126",
        },
      ],
    },
    {
      image: {
        src: "/esgplay/founders/edwin-palacin.png",
        alt: "Edwin Palacin Picture",
      },
      name: `Edwin "traNksed" Palacin`,
      role: "COO and Co-Founder",
      details:
        "Licenciado en Marketing de la ISIL y Diplomado en Marketing Digital por la IPAE, es el actual encargado de las comunicaciones y eventos a realizarse en la plataforma, además del mantenimiento de los servidores de CS:GO",
      socialMediaLinks: [
        {
          social: "email",
          href: "mailto:epalacin@esgplay.com",
        },
        {
          social: "facebook",
          href: "https://www.facebook.com/traNksed/",
        },
        {
          social: "twitter",
          href: "https://twitter.com/edwinpalacin",
        },
        {
          social: "linkedin",
          href: "https://www.linkedin.com/in/edwinpalacin/",
        },
        {
          social: "discord",
          href: "traNksed#2358",
        },
      ],
    },
  ],
  paragraph: [
    "A lo largo de los años, hemos conocido a personas increíbles que han puesto su granito de arena en ESGPLAY y, a pesar de que ya no se encuentran con nosotros, les agradecemos de corazón que hayan contribuido con el desarrollo de este proyecto. Pronto lanzaremos una página dedicada a ellos, incluyendo también a cada colaborador / streamer / creador de contenido que ha contribuido desde los inicios de la plataforma.",
    `Creemos que es hora de que ESGPLAY pase a evolucionar en el contenido que brinda no solamente para los jugadores de CS:GO, sino de cualquier Esports en el Perú como también de América Latina, por lo que estén atentos a los avances tecnológicos que iremos haciendo durante los proximos años. Si, dije AÑOS.`,
  ],
  thanks:
    "Por último, aquellos que tienen su VIP o que alguna vez lo tuvieron... ¡GRACIAS! ¡Nos permitiste mantener ESGPLAY vivo y te lo agradecemos mucho!",
  contact: {
    company: 'ESGPLAY S.A.C.',
    location: 'Jirón Los Jazmines 261, Lince, 15046, Perú',
  },
};
